import { boolean, object, string, array, number } from 'yup';

export default object().shape({
  name: string().required('Name is required'),
  address: string().required('Address is required'),
  city: string().required('City is required'),
  state: string().required('State is required'),
  zipcode: string().required('Zip code is required'),
  unitsCount: number().required('Units Count is required'),
  isBuildingRequired: boolean(),
  buildingsNames: array().when('isBuildingRequired', {
    is: true,
    then: array()
      .of(string().required(' '))
      .min(2, 'Please add more than 2 buildig names')
  }),
  bedroomsCounts: array()
    .required('Bedrooms count is required')
    .min(1, 'Please select at least 1 bedroom')
});
